<script>
export default {
  name: 'AkOptionSelect',
  props: {
    options: {
      type: Array,
      required: true,
    },
    modelValue: {
      type: Object,
      required: true,
    },
    validator: {
      type: Object,
    },
  },
  emits: ['update:modelValue'],
};
</script>

<template>
  <div class="flex flex-col gap-1">
    <button
      v-for="option in options"
      :key="option.value"
      @click="$emit('update:modelValue', option.value)"
      class="bg-white border border-grey-100 px-4 py-3.5 text-grey-900 text-left rounded-md font-medium hover:border-grey-300/60 focus-visible:border-grey-300/60 active:border-secondary"
      :class="{'!border-secondary !bg-secondary-50 text-secondary-800': modelValue === option.value}">
      {{ option.label }}
    </button>
  </div>
</template>

<style scoped></style>
